<p-toast></p-toast>
<h2 class="table-title">{{ 'i18n.domain.product-template.overview.title' | translate }}</h2>
<div class="main-table">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        label="{{ 'i18n.domain.product-template.overview.create' | translate }}"
        icon="pi pi-plus"
        class="mx-2"
        (onClick)="openNew()"
      ></p-button>
      <p-button
        label="{{ 'i18n.domain.product-template.overview.publish' | translate }}"
        icon="pi pi-send"
        class="mx-2"
        (onClick)="openPublishWizard()"
      ></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <div class="flex align-items-center justify-content-between">
        <app-search-field
          (searchTextChanged)="onSearchTextChanged($event)"
        ></app-search-field>
      </div>
    </ng-template>
  </p-toolbar>
  <p-table
    [value]="data"
    [rows]="pagedQuery.take"
    [paginator]="true"
    [globalFilterFields]="globalFilters"
    [rowHover]="true"
    dataKey="templateId"
    [lazy]="true"
    (onFilter)="onFilter($event)"
    (onPage)="onPageChange($event)"
    (onSort)="onSort($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} templates"
    [showCurrentPageReport]="true"
    [totalRecords]="totalNoOfRecords"
    [rowsPerPageOptions]="[10, 20, 50]"
    [filterDelay]="0"
    [filters]="columnFilters"
    styleClass="table-with-separators"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 10%">{{ 'i18n.domain.product-template.fields.preview' | translate }}</th>
        <th pSortableColumn="templateName" style="width: 25%">
          {{ 'i18n.domain.product-template.fields.name' | translate }}
          <p-sortIcon field="templateName"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="templateName"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="categoryName" style="width: 15%">
          {{ 'i18n.domain.product-template.fields.category' | translate }}
          <p-sortIcon field="categoryName"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="categoryName"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="price" style="width: 15%">
          {{ 'i18n.domain.product-template.fields.price' | translate }}
          <p-sortIcon field="price"></p-sortIcon>
          <p-columnFilter
            type="numeric"
            field="price"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          ></p-columnFilter>
        </th>
        <th pSortableColumn="lastModifiedDate" style="width: 20%">
          {{ 'i18n.domain.product-template.fields.last-modified' | translate }}
          <p-sortIcon field="lastModifiedDate"></p-sortIcon>
          <p-columnFilter
            type="date"
            field="lastModifiedDate"
            display="menu"
          ></p-columnFilter>
        </th>
        <th style="width: 15%"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
      <tr>
        <td>
          <img *ngIf="template.primaryImageUrl" [src]="template.primaryImageUrl"
            alt="Template" class="template-image" (error)="onImageError($event)" />
          <span *ngIf="!template.primaryImageUrl" class="no-image">{{ 'i18n.domain.product-template.fields.no-image' | translate }}</span>
        </td>
        <td>{{ template.templateName }}</td>
        <td>{{ template.categoryName || '-' }}</td>
        <td><i class="pi pi-indian-rupee" style="font-size: 0.7em; margin-right: 2px;"></i>{{ template.price | number: '1.2-2' }}</td>
        <td>{{ template.lastModifiedDate | date: 'short' }}</td>
        <td>
          <div class="grid-commands">
            <p-button
              icon="pi pi-pencil"
              class="mx-2 border-0"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (onClick)="editItem(template)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              class="mx-2 border-0"
              [rounded]="true"
              [outlined]="true"
              severity="danger"
              (onClick)="deleteTemplate(template)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center">{{ 'i18n.domain.product-template.overview.no-records' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<app-product-template-edit-dialog
  [visible]="itemDialog"
  [template]="template"
  [form]="form"
  [categories]="categories"
  [deliveryOptions]="deliveryOptions"
  [unitTypeOptions]="unitTypeOptions"
  [unitCategoryOptions]="unitCategoryOptions"
  [templateImages]="templateImages"
  [existingImages]="existingImages"
  [removeImageIds]="removeImageIds"
  [setPrimaryImageId]="setPrimaryImageId"
  (visibleChange)="onDialogVisibleChange($event)"
  (save)="saveTemplate()"
  (imageSelected)="onImageSelected($event)"
  (imageRemoved)="removeImage($event)"
  (existingImageRemoved)="removeExistingImage($event)"
  (primaryImageSet)="setPrimaryImage($event)"
  (primaryExistingImageSet)="setPrimaryExistingImage($event)"
></app-product-template-edit-dialog>
